import React from 'react';
import { TextButton, PrimaryButton, IconChevronLeft, IconChevronRight } from 'cdk-radial';
import { useSelector } from 'react-redux';

const PREVIOUS = 'Previous';
const LIGHT = 'light';
const ROLE = 'presentation';
const VIEW_BOX = '0 0 24 24';
const STANDARD = 'standard';

function StepperFooter({
  onNext,
  onPrevious,
  disableNextButton,
  disablePreviousButton,
  isLastStep,
  isConfigureStep
}) {
  const state = useSelector(state => state.solutionInfoSlice);

  const constants = state.constants;
  const appSubscriptionType =
    state.solutionInfo?.app_subscriptions?.appSubscriptionsType;

  const nextButtonLabel = isLastStep
    ? constants?.COMPLETE_BUTTON
    : isConfigureStep
      ? 'Configure'
      : 'Next';

  return (
    <div className="stepper-footer-container">
      {!isConfigureStep ? <div className="stepper-footer-previous-button">
        <TextButton
          onClick={() => onPrevious()}
          isDisabled={disablePreviousButton}
          text={PREVIOUS}
          icon={
            <IconChevronLeft
              focusable={false}
              height={12}
              role={ROLE}
              viewBox={VIEW_BOX}
              width={12}
            />
          }
        />
      </div>: null}
      {!isConfigureStep || (isConfigureStep && appSubscriptionType !== 'Manual') ? (
        <div className="stepper-footer-next-button">
          <PrimaryButton
            onClick={() => onNext()}
            isDisabled={disableNextButton}
            text={nextButtonLabel}
            backgroundAppearance={LIGHT}
            icon={<IconChevronRight />}
            iconSize={24}
            isIconTrailing
            preserveClickableArea={false}
            size={STANDARD}
          />
        </div>
      ) : null}
    </div>
  );
}

export default StepperFooter;
